<template>
  <CreateWalletDrawer @stablecoin-selected="handleStablecoinSelected" />
  <CreateWalletStablecoinDrawer
    :model-value="isStablecoinDrawerOpen"
    :currency="selectedCurrency"
    @close="closeStablecoinDrawer"
  />
</template>

<script lang="ts" setup>
import CreateWalletDrawer from '../CreateWalletDrawer/index.vue';
import CreateWalletStablecoinDrawer from '../CreateWalletStablecoinDrawer/index.vue';
import { useCreateWalletFlow } from './useCreateWalletFlow';

const { isStablecoinDrawerOpen, selectedCurrency, handleStablecoinSelected, closeStablecoinDrawer } =
  useCreateWalletFlow();
</script>
